module.exports = __webpack_public_path__ + "img/right2.1ce006eb.png";